import { version } from "../../package.json";

// Networking
export const DEFAULT_API_RESPONSE_LIMIT = 20;
export const DEFAULT_FETCH_STATE = { pending: false, error: null, timestamp: 0 };

// Search Service
export const DEFAULT_SEARCH_SERVICE_META = { nbHits: 0, nbPages: 0, page: 0 };
export const DEFAULT_SEARCH_SERVICE_ANALYTICS = [`version:${version}`, "platform:web"];
export const SEARCH_DEFAULT_PAGE_SIZE = 20;
export const SEARCH_MAX_QUERY_LENGTH = 512;

// Head, JSDOM, etc.
export const MAX_HEAD_TITLE_LENGTH = 35;

// Page Text
export const CREATOR_SITE_TERMS_OF_SERVICE = "ltk-terms-of-service";

// UI
export const LTK_HEADER_HEIGHT = 80;
export const SEARCH_SUGGESTIONS_DEBOUNCE_DELAY = 200;
export const SEARCH_SUGGESTIONS_LIMIT = 5;
export const SEARCH_FETCH_DEBOUNCE_DELAY = 500;
export const CREATOR_SHOP_PRODUCT_FEED_COLUMNS: Record<string, number> = { xl: 4, lg: 4, md: 3, sm: 3, xs: 2 };

export const REDIRECT_IGNORE_PATHS = ["/", "/auth", "/auth/callback", "/logout", "/ltk-shopping-app", "/ltk-chat"];

// class constants
export const LTK_COACHMARK_CLASS_NAME = "ltk-coachmark";
